// extracted by mini-css-extract-plugin
export var root = "P_xN";
export var wrapper = "P_s6";
export var image = "P_xP d_v d_x d_V";
export var crop = "P_xQ";
export var round = "P_xR";
export var fixedHeight = "P_xS";